// extracted by mini-css-extract-plugin
export default {"inputWrapper":"SearchTask_inputWrapper__eY7qp","searchRow":"SearchTask_searchRow__LdQP-","searchIcon":"SearchTask_searchIcon__1trdL","searchInput":"SearchTask_searchInput__n-rED"};